// extracted by mini-css-extract-plugin
module.exports = {"root":"Loadingblock_root__3He9g","loadingRipple":"Loadingblock_loadingRipple__YGB1I"};